export default __webpack_public_path__ + "static/media/pulse.c8bab3d2.png";